import clsx from "clsx";

type Props = {
	bold?: boolean;
	children?: React.ReactNode;
};

const InvoiceTotalsDetailLabel = ({ bold = false, children }: Props) => {
	return <div className={clsx("flex h-8 items-center text-gray-800", bold ? "font-bold" : "")}>{children}</div>;

};

export default InvoiceTotalsDetailLabel;